import { LoaderSpinnerComponent } from '@aston/foundation/components';
import { Component, OnInit, inject } from '@angular/core';

import { AuthenticationService } from '../../services';


@Component({
	selector: 'logout-page',
	templateUrl: './logout-page.component.html',
	imports: [LoaderSpinnerComponent]
})
export class LogoutPageComponent implements OnInit {
	private authenticationService = inject(AuthenticationService);


	ngOnInit() {
		this.authenticationService.logout();
	}

}
